import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, Observable, retry, throwError, timer } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesEnum } from '../../../shared/models/routes.enum';
import { NotificationService } from '../../../shared/services/notification/notification.service';

enum HttpStatusCode {
  NoConnection = 0,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
}

const RETRY_TIMES = 2;
const DELAY = 2000;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  return next(req).pipe(
    retry({ count: RETRY_TIMES, delay: (error: HttpErrorResponse) => shouldRetry(error) }),
    catchError(error => {
      let errorMessage = error.error?.message || error.error || error.statusText;

      if (Array.isArray(error.error)) {
        errorMessage = error.error.join(' ');
      }

      if (error instanceof HttpErrorResponse) {
        switch (error.status) {
          case HttpStatusCode.NoConnection:
            errorMessage = `Brak połączenia internetowego. Sprawdź sieć i spróbuj ponownie.`;
            break;
          case HttpStatusCode.Unauthorized:
            errorMessage = `Nie masz uprawnień do wykonania tej czynności. Zaloguj się i spróbuj ponownie.`;

            if (error.url && error.url.includes('get-user-info')) {
              errorMessage = `Twoja sesja wygasła. Wylogowano pomyślnie.`;
            } else {
              router.navigate([`/${RoutesEnum.Login}`]);
            }

            break;
          case HttpStatusCode.Forbidden:
            errorMessage = `Nie możesz wykonać tej akcji.`;
            break;
          case HttpStatusCode.NotFound:
            errorMessage = `Nie znaleziono zasobu.`;

            if (error.url && error.url.includes('auth/login')) {
              errorMessage = `Nieprawidłowy login lub hasło.`;
            }

            if (error.url && error.url.includes('/rounds/')) {
              errorMessage = `Brak turnieju o podanym identyfikatorze.`;
            }

            if (error.url && error.url.includes('/get-rounds/')) {
              errorMessage = `Nieprawidłowy kod`;
            }
            break;
        }
        notificationService.error(errorMessage);
      }
      return throwError(() => new Error(errorMessage));
    }),
  );
};

function shouldRetry(error: HttpErrorResponse): Observable<number> {
  if (error.status >= 500) {
    return timer(DELAY);
  }
  throw error;
}
